class tptCollectionCard extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.showCollectionDetail.bind(this));
	}

	showCollectionDetail(event) {
		event.preventDefault();

		const url = this.getAttribute('data-url');
		const documentWidth = document.body.offsetWidth;

		this.detailContainer = '';

		/**
		 * Remove active all collection item
		 */
		document.querySelectorAll('.collection-list .collection-list_item').forEach((collectionItem) => {
			collectionItem.classList.remove('active');
		});

		/**
		 * Active item and collection detail
		 */
		this.closest('.collection-list .collection-list_item').classList.add('active');

		if (documentWidth >= 1200) {
			this.detailContainer = document.querySelector('.collection-list .collection-list_item.active ~ [data-detail-screen="desktop"]');
		}

		if (documentWidth >= 769 && documentWidth < 1200) {
			this.detailContainer = document.querySelector('.collection-list .collection-list_item.active ~ [data-detail-screen="tablet"]');
		}

		if (documentWidth < 769) {
			this.detailContainer = document.querySelector('.collection-list .collection-list_item.active ~ [data-detail-screen="mobile"]');
		}

		//this.detailContainer = document.querySelector('.collection-list .collection-list_item.active ~ [data-detail-screen="desktop"]');

		this.detailContainer.classList.add('active', 'loading');

		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const currentModal = this.detailContainer;

				document.querySelectorAll('.collection-list .collection-detail').forEach((collectionDetail) => {
					collectionDetail.classList.remove('active', 'loading');
					collectionDetail.innerHTML = '';
				});

				const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
				const detailHtml = responseHTML.querySelector('.shopify-section').innerHTML;

				this.detailContainer.innerHTML = detailHtml;

				window.scroll({
					top: this.detailContainer.offsetTop - 100,
					behavior: 'smooth',
				});

				if (documentWidth >= 1200) {
					setTimeout(() => {
						currentModal.focus();
					}, 300);
				}
			})
			.finally(() => {});
	}
}

customElements.define('tpt-collection-card', tptCollectionCard);

/**
 * Close collection card detail
 */
class tptCloseCollectionCard extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.closeCollectionDetail.bind(this));
		this.addEventListener('keydown', this.keyDown.bind(this));
	}

	keyDown(e) {
		if (e.keyCode === 13) {
			this.closeCollectionDetail();
		}
	}

	closeCollectionDetail() {
		this.closest('collection-card-detail').innerHTML = '';
	}
}

customElements.define('tpt-close-collection-card', tptCloseCollectionCard);
